import type * as React from 'react';
import type { FC } from 'react';

import { Loadable } from '@crehana/web';

import type { GetLeadBannerSnackBarProp } from './GetLeadBannerSnackBar';

const LazyGetLeadBannerSnackBar: FC<
  React.PropsWithChildren<GetLeadBannerSnackBarProp>
> = props => (
  <Loadable
    module={() =>
      import(
        /* webpackChunkName: "GetLeadBannerSnackBar" */
        './GetLeadBannerSnackBar'
      )
    }
    Loader={<div className="sm:h-72" />}
    {...props}
  />
);

export default LazyGetLeadBannerSnackBar;
